import { useNavigate } from 'react-router-dom';
import concertImage from '../../../assets/events/concert.png';
import conferenceImage from '../../../assets/events/conference.png';

export default function OrganizerSection() {
  const navigate = useNavigate();

  const events = [
    {
      title: 'Gospel',
      type: 'Soirée Gospel Live',
      date: '1 Juin 2026',
      price: '10 000 FCFA',
      seats: '755 /  800',
      img: concertImage,
      typeColor: 'bg-rose-100 text-rose-600',
    },
    {
      title: 'Conférence chrétienne',
      type: 'Conférence Foi & Leadership',
      date: '25 Mai 2026',
      price: '3 000 FCFA',
      seats: '320 / 500',
      img: conferenceImage,
      typeColor: 'bg-rose-100 text-rose-600',
    },
  ];

  const benefits = [
    { icon: 'ri-calendar-event-line', label: "Création d'événements facile" },
    { icon: 'ri-ticket-2-line', label: 'Vente de tickets en ligne' },
    { icon: 'ri-funds-line', label: 'Suivi financier en temps réel' },
    { icon: 'ri-qr-code-line', label: 'Billets QR code sécurisés' },
    { icon: 'ri-team-line', label: 'Gestion des participants' },
    { icon: 'ri-pie-chart-line', label: 'Rapports de performance' },
  ];

  return (
    <section id="organizers" className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
          <div className="relative space-y-4">
            {events.map((event) => (
              <div key={event.title} className="flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white">
                <div className="h-44 w-full overflow-hidden">
                  <img src={event.img} alt={event.title} className="h-full w-full object-cover object-top" />
                </div>
                <div className="flex items-center gap-4 p-4">
                  <div className="flex-1">
                    <div className="mb-1 flex items-center gap-2">
                      <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${event.typeColor}`}>{event.type}</span>
                      <span className="text-xs text-gray-400">{event.date}</span>
                    </div>
                    <p className="text-sm font-bold text-navy">{event.title}</p>
                    <p className="mt-0.5 text-xs text-gray-400">{event.seats} places vendues</p>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <p className="text-base font-bold text-gold-dark">{event.price}</p>
                    <p className="text-xs text-gray-400">par ticket</p>
                  </div>
                </div>
              </div>
            ))}

            <div className="absolute -right-4 -top-4 rounded-xl border border-gold/30 bg-white p-3 shadow-sm">
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gold-100">
                  <i className="ri-money-dollar-circle-line text-sm text-gold-dark"></i>
                </div>
                {/* <div>
                  <p className="text-xs font-bold text-navy">2.4M FCFA</p>
                  <p className="text-xs text-gray-400">Revenus ce mois</p>
                </div> */}
              </div>
            </div>
          </div>

          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold-100 px-4 py-2">
              <i className="ri-calendar-event-line text-sm text-gold-dark"></i>
              <span className="text-sm font-semibold text-gold-dark">Pour les Organisateurs</span>
            </div>
            <h2 className="mb-6 text-4xl font-bold text-navy md:text-5xl">
              Créez des
              <br />
              <span className="text-gold-dark">événements</span>
              <br />
              mémorables.
            </h2>
            <p className="mb-8 text-lg leading-relaxed text-gray-500">
              De la création à la vente de tickets, en passant par la gestion des participants et l'analyse financière, Foi Senegal vous donne tous les outils pour organiser des événements réussis.
            </p>

            <div className="mb-10 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {benefits.map((benefit) => (
                <div key={benefit.label} className="flex items-center gap-3">
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-gold-100">
                    <i className={`${benefit.icon} text-sm text-gold-dark`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{benefit.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => navigate('/register')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-gold px-6 py-3.5 text-sm font-bold text-white transition-all hover:bg-gold-dark"
              >
                <i className="ri-calendar-event-line"></i>
                Devenir organisateur
              </button>
              <div className="flex items-center gap-3 text-sm text-gray-500">
                <div className="flex -space-x-2">
                  {[
                    'https://readdy.ai/api/search-image?query=african%20event%20organizer%20professional%20confident%20portrait%20warm%20smile&width=32&height=32&seq=ao1&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=african%20man%20professional%20event%20organizer%20portrait&width=32&height=32&seq=ao2&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=african%20woman%20professional%20organizer%20confident%20portrait&width=32&height=32&seq=ao3&orientation=squarish',
                  ].map((src) => (
                    <img key={src} src={src} alt="" className="h-8 w-8 rounded-full border-2 border-white object-cover object-top" />
                  ))}
                </div>
                <span>
                  <strong className="text-navy">850+</strong> événements organisés
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
